import React, { useState, useEffect } from 'react';
import { answerInvestorApi, investorApi } from '../../services/adminApi';
import Swal from 'sweetalert2';
import '../../styles/AdminPages.css';

const AnswerInvestorPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [investors, setInvestors] = useState({});

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await answerInvestorApi.getAll();
      const items = response?.data || response || [];
      setData(Array.isArray(items) ? items : []);
      setError(null);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err.message || 'Failed to load data');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchInvestors = async () => {
    try {
      const response = await investorApi.getAll({ pageSize: 1000 });
      const items = response?.data || response || [];
      const investorMap = {};
      items.forEach(inv => {
        investorMap[inv.investorId] = `${inv.firstName || ''} ${inv.lastName || ''}`.trim() || inv.email || inv.investorId;
      });
      setInvestors(investorMap);
    } catch (err) {
      console.error('Error fetching investors:', err);
    }
  };

  useEffect(() => {
    fetchData();
    fetchInvestors();
  }, []);

  const handleDelete = async (item) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0a2540',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        await answerInvestorApi.delete(item.investorId, item.answerId);
        Swal.fire('Deleted!', 'The record has been deleted.', 'success');
        fetchData();
      } catch (err) {
        Swal.fire('Error!', err.message || 'Failed to delete', 'error');
      }
    }
  };

  const filteredData = data.filter(item => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    const investorName = investors[item.investorId] || '';
    return (
      item.investorId?.toString().toLowerCase().includes(searchLower) ||
      item.answerId?.toString().toLowerCase().includes(searchLower) ||
      investorName.toLowerCase().includes(searchLower)
    );
  });

  if (loading) {
    return (
      <div className="admin-page">
        <div className="admin-page-header">
          <h1>Answer Investor</h1>
          <p className="admin-subtitle">Manage investor survey responses</p>
        </div>
        <div className="admin-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Answer Investor</h1>
          <p className="admin-subtitle">Manage investor survey responses</p>
        </div>
      </div>

      {error && (
        <div className="admin-error">
          {error}
          <button onClick={fetchData} className="admin-btn admin-btn-secondary" style={{ marginLeft: '10px' }}>
            Retry
          </button>
        </div>
      )}

      <div className="admin-toolbar">
        <input
          type="text"
          placeholder="Search by investor ID or name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="admin-search-input"
        />
        <span className="admin-count">{filteredData.length} records</span>
      </div>

      <div className="admin-table-container">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Investor ID</th>
              <th>Investor Name</th>
              <th>Answer ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="4" className="admin-no-data">No records found</td>
              </tr>
            ) : (
              filteredData.map((item, index) => (
                <tr key={`${item.investorId}-${item.answerId}-${index}`}>
                  <td>{item.investorId}</td>
                  <td>{investors[item.investorId] || '-'}</td>
                  <td>{item.answerId}</td>
                  <td>
                    <button
                      onClick={() => handleDelete(item)}
                      className="admin-btn admin-btn-danger admin-btn-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnswerInvestorPage;
